import React, { useState, useEffect } from 'react';
import { Parallax, ParallaxBanner } from 'react-scroll-parallax';
import styled from 'styled-components';
import { ACCENT_COLOR, BTN, NAME_SECTION } from '../styles/style';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import BgImg from '../images/bg.jpg';
import { smoothScrollTo } from '../utils/scroll';
import { useMemo } from 'react';

const Section = styled.section`
min-height: 100vh;
background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  /* &::after{
    content: "HOME";
    top: 35% !important;
    font-size:7rem !important;
    ${NAME_SECTION};
    @media(min-width:768px){
      font-size:16rem !important;
    }
  } */
  .title{
    z-index: 1;
    position: relative;
    .section-name {
  position: absolute;
  top:-50%;
  left: 50%;
  font-family: Poppins;
  font-weight: bold;
  transform: translateX(-50%);
  font-size: 6rem;
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;
  @media (min-width: 768px) {
    font-size: 14rem;
    top: -150%;
  }
}
    h1{
      span{
        color:white;
        font-weight: bold;
      }
        font-weight: 100;
        letter-spacing: -2px;
        font-size:3rem;
        line-height: 3rem;
        @media(min-width:786px){
          font-size:4rem;
          line-height: 4rem;
        }
    }
    .subtitle{
      letter-spacing: 2px;
    }
  }
  .btn{
    ${BTN};
  }
`;
const AnimatedText = styled(motion.div)`
  font-size: 2rem;
  color: white;
`;

const titles = ['Web Developer', 'Freelancer'];

const Home = () => {
  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [speed, setSpeed] = useState(100);

  const handleAboutClick = () => smoothScrollTo('about');

  useEffect(() => {
  const current = titles[index % titles.length];
  let timeout;

  if (!isDeleting && text === current) {

    timeout = setTimeout(() => {
      setIsDeleting(true);
      setSpeed(60);
    }, 1500);
  } else if (isDeleting && text === '') {

    timeout = setTimeout(() => {
      setIsDeleting(false);
      setIndex(prev => prev + 1);
      setSpeed(100);
    }, 500); 
  } else {
    timeout = setTimeout(() => {
      setText(prev =>
        isDeleting ? current.substring(0, prev.length - 1) : current.substring(0, prev.length + 1)
      );
    }, speed);
  }

  return () => clearTimeout(timeout);
}, [text, isDeleting, index]);

    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
        const options = useMemo(() => ({
        triggerOnce: true,
        threshold: isMobile ? 0.3 : 0.6,
        rootMargin: isMobile ? '-60px 0px 0px 0px' : '-100px 0px 0px 0px',
      }), []);
      
      const [ref, inView] = useInView(options);
  return (
    <ParallaxBanner
    layers={[
      {
        image: BgImg,
        speed: -40,
      },
    ]}
    style={{ height: '100vh' }}
  >
    <Section id="home" ref={ref}>
      <AnimatedText
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <div className='title'>
          <div className="section-name">HOME</div>
          <h1>WOJCIECH <span>TAŁANDA</span></h1>
          <p className='subtitle'><span>{text}</span><span className="cursor">|</span></p>
        </div>
        <button className="btn" onClick={handleAboutClick}>O mnie</button>
      </AnimatedText>
    </Section>
  </ParallaxBanner>
  );
};

export default Home;
